

<div class="modal-header bg-blu txt-white">
  Report Zone OMI
  <button type="button" class="close text-white" aria-label="Close" (click)="activeModal.close()">
     <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body p-0 overflow-custom">
    <table *ngIf="reports.length > 0" class="table">
      <thead>
        <tr>
          <th scope="col">Nome</th>
          <th scope="col">Tipologia</th>
          <th scope="col">Zona</th>
          <th scope="col">Stato</th>
          <th scope="col">Comune</th>
          <th scope="col">Provincia</th>
          <th scope="col">Regione</th>
          <th scope="col">Area Territoriale</th>
          <th scope="col">Fascia</th>
          <th scope="col">Sezione</th>
          <th scope="col">Stato Prev</th>
          <th scope="col">Compr. Min.</th>
          <th scope="col">Compr. Max</th>
          <th scope="col">Sup. Nl. Compr.</th>
          <th scope="col">Loc. Min.</th>
          <th scope="col">Loc. Max</th>
          <th scope="col">Sup Nl. Loc.</th>
          </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let data of reports; let rowIndex = index">
          <tr>
            <td scope="col">{{data.properties.name}}</td>
            <td scope="col">{{data.properties.descr_tipologia}}</td>
            <td scope="col">{{data.properties.zona}}</td>
            <td scope="col">{{data.properties.stato}}</td>
            <td scope="col">{{data.properties.comune_descrizione}}</td>
            <td scope="col">{{data.properties.provincia}}</td>
            <td scope="col">{{data.properties.regione}}</td>
            <td scope="col">{{data.properties.area_territoriale}}</td>
            <td scope="col">{{data.properties.fascia}}</td>
            <td scope="col">{{data.properties.sezione}}</td>
            <td scope="col">{{data.properties.stato_prev}}</td>
            <td scope="col">{{data.properties.compr_min}}</td>
            <td scope="col">{{data.properties.compr_max}}</td>
            <td scope="col">{{data.properties.sup_nl_compr}}</td>
            <td scope="col">{{data.properties.loc_min}}</td>
            <td scope="col">{{data.properties.loc_max}}</td>
            <td scope="col">{{data.properties.sup_nl_loc}}</td>
          </tr>
        </ng-container>
      </tbody>
  </table>
</div>
<div class="modal-footer bg-light">
  <button type="button" class="btn btn-bg-outline" (click)="activeModal.close()">Chiudi</button>
</div>